// Task #1208 — Pure tab-routing helpers extracted from app-messages.tsx so they
// can be imported in server-side vitest tests without pulling in React/UI deps.

export type Tab = "inbox" | "houseChats" | "awaiting" | "waitingReplies" | "scheduled" | "rules" | "canned";

export const TAB_IDS: readonly Tab[] = ["inbox", "houseChats", "awaiting", "waitingReplies", "scheduled", "rules", "canned"];

/**
 * Resolves a raw ?tab= query string value to a valid Tab.
 * "drafts" is kept as an alias for "awaiting" for sidebar-badge backwards compat.
 */
export function resolveTab(raw: string | null | undefined): Tab {
  if (raw === "awaiting" || raw === "drafts") return "awaiting";
  if (raw === "waitingReplies") return "waitingReplies";
  if (raw === "houseChats") return "houseChats";
  if (raw === "scheduled") return "scheduled";
  if (raw === "rules") return "rules";
  if (raw === "canned") return "canned";
  return "inbox";
}

/**
 * The approval queue, excluding already delivered or cancelled rows. Rule
 * drafts and AI auto-drafts set to "Never" (no rule, automationSource
 * "auto_draft") both wait here for a host.
 */
export function isDraftMessage(row: {
  autoSend: boolean | null;
  ruleId?: number | null;
  automationSource?: string | null;
  sentAt?: unknown;
  cancelledAt?: unknown;
  reconciledChatId?: unknown;
}) {
  return row.autoSend === false && (row.ruleId != null || row.automationSource === "auto_draft") &&
    row.sentAt == null && row.cancelledAt == null && row.reconciledChatId == null;
}
